import React, { useEffect, useState } from 'react'
import FadeIn from 'react-fade-in/lib/FadeIn'
import { Button, Container, Modal, ModalBody, ModalFooter, ModalHeader, Table } from 'reactstrap'
import Select from 'react-select';
import { GetCookieData, GetCookieToken } from '../Cookie/GetCookie';
import axios from 'axios';
import { filterLastVersionData } from './evaluateConfig';
import LoadingData from '../TESTPage/LoadingData';
const API_URL = process.env.REACT_APP_API_CORS;

export function HistoryEvaluate(props) {
  const userData = GetCookieData("userData");
  const token = GetCookieToken("userToken");
  const { open = false, toggle, data = [], thisEvaluateUserId, evaluateData, loading, loadingProps = {}, } = props
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const scoreHistoryData = filterLastVersionData(data, thisEvaluateUserId)

  return (
    <Modal isOpen={open} toggle={toggle} centered size="xl">
      <ModalHeader toggle={toggle}></ModalHeader>
      <ModalBody >
        <FadeIn>
          <Container fluid>
            {loading ? <LoadingData /> : (<Table className="align-middle" striped style={{ overflowX: "scroll", fontSize: "16px" }} responsive>
              <thead className="table-light" style={{ whiteSpace: `${windowSize.width < 576 ? "nowrap" : "normal"}` }}>
                <tr>
                  <th className="text-center">ลำดับ</th>
                  <th >ชื่อผู้ประเมิน</th>
                  <th className="text-center">คะแนนประเมิน<br/>ผลสัมฤทธิ์ของงาน</th>
                  <th className="text-center">คะแนนประเมิน<br/>พฤติกรรมการปฏิบัติราชการหรือสมรรถนะ</th>
                  <th className="text-center">คะแนนสรุปการประเมิน<br/>ผลการปฏิบัติราชการ</th>
                </tr>
              </thead>
              <tbody style={{ whiteSpace: "nowrap", fontSize: "15px" }}>
                {scoreHistoryData.length > 0 ?
                  scoreHistoryData.map((item, idx) => (
                    <tr key={idx}>
                      {/* <td>
                        {item.seq === 8 ? "ประเมินตนเอง"
                          : item.seq === 7 ? "ประเมินโดยผู้อำนวยการกลุ่ม"
                            : item.seq === 6 ? "ประเมินโดยผู้เชี่ยวชาญกอง"
                              : item.seq === 5 ? "ประเมินโดยผู้อำนวยการกอง"
                                : item.seq === 4 ? "ประเมินผู้ช่วยเลขาธิการ ก.พ.ร."
                                  : item.seq === 3 ? "ประเมินโดยรองเลขาธิการ"
                                    : item.seq === 9 ? "ประเมินโดยคณะกรรมกลั่นกรอง"
                                      : item.seq === 2 ? "ประเมินโดยเลขาธิการกพร."
                                        : ""}
                      </td> */}
                      <td className="text-center">{idx + 1}</td>

                      <td>{item.seq === 8 ? evaluateData?.user_name : item.approve_user}</td>

                      <td className="text-center">{Number(item.first_score).toFixed(4)}</td>
                      <td className="text-center">{Number(item.second_score).toFixed(4)}</td>
                      <td className="text-center">{Number(item.total_score).toFixed(4)}</td>
                    </tr>
                  ))
                  :
                  <tr>
                    <td colSpan="10" className="text-center fs-5">
                      ไม่มีข้อมูล
                    </td>
                  </tr>
                }

              </tbody>
            </Table>)}
          </Container>
        </FadeIn>
      </ModalBody>
    </Modal>
  )
}


export function SortEvaluate(props) {
  const { openSort = false, toggleSort, data = [], getData, prefixAndPlachoder, headers, task = "" } = props
  const [org, setOrg] = useState(null);

  return (
    <Modal isOpen={openSort} toggle={toggleSort} size="lg">
      <ModalHeader>
        {headers}
      </ModalHeader>
      <ModalBody >
        <FadeIn>
          <Container fluid>
            <Select
              className="basic-single"
              classNamePrefix={`${prefixAndPlachoder}`}
              defaultValue='0'
              isSearchable={true}
              name="color"
              placeholder={`${prefixAndPlachoder}...`}
              options={data}
              onChange={(e) => { setOrg(e?.value) }}
            />
          </Container>
        </FadeIn>
      </ModalBody>
      <ModalFooter>
        <Button color='success' disabled={org === null ? true : false} className='ps-2' onClick={() => { getData(undefined, undefined, org, task); toggleSort(); }}>เลือก</Button>
        <Button color='danger' onClick={toggleSort}>ยกเลิก</Button>
      </ModalFooter>
    </Modal>
  )
}
